import React from "react";
import "./Roadmap.css";
import { Container } from "react-bootstrap";
import Accordian from "../Accordian/Accordian";

export default function Roadmap() {
  return (
    <section id="roadmap">
      <Container>
        <div className="content">
          <h4 className="sm-title">Colaborações</h4>
          <div className="top-text">
            <h1 className="lg-title">Colaborações e Afiliações</h1>
            <h2 className="desc">
            Estabelecemos parcerias estratégicas com líderes de mercado e organizações proeminentes para impulsionar a inovação e promover o crescimento contínuo. Através de colaborações estratégicas e afiliações criteriosas, fortalecemos nossa rede de recursos e expertise, garantindo resultados de excelência para nossos clientes e parceiros.
            </h2>
          </div>
        </div>
      </Container>
      <div className="customContainer">
       {/*COMMENTED TEMP <Accordian /> */}
        
      </div>
    </section>
  );
}
